import { render, staticRenderFns } from "./SchForm.vue?vue&type=template&id=76521d75&"
import script from "./SchForm.vue?vue&type=script&lang=js&"
export * from "./SchForm.vue?vue&type=script&lang=js&"
import style0 from "./SchForm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports